import React from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import { compose } from 'redux';

import Tabs from '../../../constants/tabs';
import withProjectSidebar from '../../../components/with-project-sidebar';
import ReportViewUI from './report-view-ui';

import { GET_REPORT_BY_PROJECT_ID } from './graphql';

const ReportView = (props) => {
  const { project } = props;
  const {
    data = {},
    loading,
    error,
  } = useQuery(GET_REPORT_BY_PROJECT_ID, {
    variables: { projectId: project.id },
  });

  const {
    reports: [
      {
        name,
        reportData,
        testSessionNotes,
        highlightReels,
      } = {}] = [],
  } = data;

  return (
    <ReportViewUI
      name={name}
      reportData={reportData}
      testSessionNotes={testSessionNotes}
      highlightReels={highlightReels}
      loading={loading}
      error={error}
    />
  );
};

const enhance = compose(
  withProjectSidebar({ selectedTab: Tabs.PROJECT }),
);

ReportView.propTypes = {
  project: PropTypes.shape({
    id: PropTypes.string,
  }).isRequired,
};

export default enhance(ReportView);
